import {AttrsSchema, Component} from 'panel';

import {ButtonTheme, ButtonType} from 'common/components/button/constants';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {Formula} from '../types';
import {template} from './template';
import css from './index.inline.styl';

type InsightsFormulaClauseState = {
  formula?: Formula;
  open: boolean;
};

type InsightsFormulaClauseAttrs = {
  theme?: ButtonTheme;
  error?: string;
};

export class InsightsFormulaClause extends Component<InsightsFormulaClauseState, InsightsFormulaClauseAttrs> {
  static get attrsSchema(): AttrsSchema<InsightsFormulaClauseAttrs> {
    return {
      ...super.attrsSchema,
      theme: {type: `string`, default: `secondary`},
      error: `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        formula: null,
        open: false,
      },
      helpers: {
        ButtonType,
        handleLabelClick: () => {
          this.update({open: !this.state.open});
        },

        handleMenuChange: (ev) => {
          if (ev.detail && ev.detail.state === `closed` && this.state.open) {
            this.update({open: false});
          }
        },

        handleRemoveClick: (ev) => {
          ev.preventDefault();
          this.dispatchEvent(new CustomEvent(`delete`));
        },

        handleSave: (ev) => {
          const updatedFormula = {...this.state.formula, ...ev.detail} as Formula;
          this.dispatchEvent(new CustomEvent(`update`, {detail: {formula: updatedFormula}}));
          this.update({open: false});
        },
      },
    };
  }

  set formula(formula: Formula) {
    this.update({formula});
  }

  shouldUpdate(stateUpdate) {
    return !!stateUpdate.formula;
  }
}

export const InsightsFormulaClauseEl = defineAndMakeJsxFactory(`insights-formula-clause`, InsightsFormulaClause);
export const InsightsFormulaClauseReact = panel2react(`insights-formula-clause`, InsightsFormulaClause);
